import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutService } from '@spike/scaffolds';
import { menuItems } from './config/app.menu.config';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  imports: [RouterOutlet],

})
export class App {
    constructor(layoutService:LayoutService){
      layoutService.setMenu(menuItems);
      layoutService.setApplicationName('MyWallet');
      
    }

}